/**
 * Fügt eine Klasse hinzu, wenn ein Element vom Selektor über den ViewPort nach links oder rechts hinausragt
 * @param selector
 * @param classNameLeft
 * @param classNameRight
 */
function navigationDropdownPosition(selector, classNameLeft, classNameRight) {
    var windowRight = $(window).scrollLeft() + $(window).width();
    var windowLeft = $(window).scrollLeft();
    $(selector).each(function() {
        $(this).removeClass(classNameLeft);
        $(this).removeClass(classNameRight);
        if (windowLeft > $(this).offset().left) {
            $(this).addClass(classNameLeft);
        }
        if (windowRight < $(this).offset().left + $(this).outerWidth()) {
            $(this).addClass(classNameRight);
        }
    });
}
